import Mitt from 'mitt'

const eventBus = new Mitt()
export default eventBus
